var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.552 0.625C9.70825 0.5 9.927 0.5 10.0833 0.625L14.2083 4.75C14.3333 4.90625 14.3333 5.125 14.2083 5.28125L10.0833 9.40625C9.927 9.53125 9.70825 9.53125 9.552 9.40625L8.927 8.78125C8.802 8.625 8.802 8.40625 8.95825 8.25L11.4583 5.8125H0.708252C0.489502 5.8125 0.333252 5.65625 0.333252 5.4375V4.5625C0.333252 4.375 0.489502 4.1875 0.708252 4.1875H11.4583L8.95825 1.78125C8.802 1.625 8.802 1.40625 8.927 1.25L9.552 0.625Z",
    fill: "#CE0E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedArrowIcon);
export default __webpack_public_path__ + "static/media/RedArrowIcon.954bab936cdaf847badd5ca9cd0658eb.svg";
export { ForwardRef as ReactComponent };